/**
* description:
* File of container LoginSubscriberPasswordForm Component (Dumb)
*
* data : 2017-08-03
*/

import { mapActions } from 'vuex';

// CHILD COMPONENTS ////////////////////////////////////////////////////////////
import SmallLoadingSpinner from '@/components/Common/SmallLoadingSpinner';
import LoginErrorMessage from '@/components/Login/LoginErrorMessage';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'LoginSubscriberPasswordForm',

  components: {
    LoginErrorMessage, SmallLoadingSpinner,
  },

  props: ['subscriber', 'loginCredentialsIncorrect', 'loginLoadingActive'],

  data() {
    return {
      password: null,
      passwordHidden: true,
    };
  },

  beforeMount() {
    this.resetPassword();
  },

  methods: {
    ...mapActions(['validatePassword', 'undoLoginState', 'confirmChangePassword']),
    returnToNumberInput() {
      this.undoLoginState('initial');
    },
    submitPassword() {
      const password = this.password;
      this.validatePassword({ password });
    },
    resetPassword() {
      this.password = null;
    },
    togglePasswordVisibility() {
      if (this.passwordHidden) {
        document.querySelector('.login-form__input--password').type = 'text';
        this.passwordHidden = false;
      } else {
        document.querySelector('.login-form__input--password').type = 'password';
        this.passwordHidden = true;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Login/LoginSubscriberPasswordForm/component.js